import React from "react";
import Meta from "../components/settings/Meta";
import { requireAuth } from "./../util/auth";
import OnboardingSteps from "../components/onboarding/OnboardingSteps";

function OnboardingPage(props) {
  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Meta title="Onboarding" />
        <OnboardingSteps />
      </div>
    </div>
  );
}

export default requireAuth(OnboardingPage);